module.exports = __webpack_public_path__ + "img/triangle-bottomText_hover.df6f6f15.png";